function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function drugPromptsTemplate(promptsArray, startIndex, trackingSection) {
    var prompts = Array.isArray(promptsArray) ? promptsArray : [];
    var sectionCode = trackingSection || 'adv';
    var baseIndex = parseInt(startIndex, 10);
    if (isNaN(baseIndex) || baseIndex < 1) {
        baseIndex = 1;
    }

    var promptsHtml = prompts.map(function(prompt, index) {
        var safePrompt = escapeHtml(prompt);
        var promptIndex = baseIndex + index;
        return '<button class="drug-prompts-cta__prompt" data-prompt="' + safePrompt + '" data-prompt-index="' + promptIndex + '" data-prompt-section="' + sectionCode + '">' +
                   '<span class="drug-prompts-cta__prompt-icon ai-sparkle" aria-hidden="true"></span>' +
                   '<span class="drug-prompts-cta__prompt-text">' + safePrompt + '</span>' +
               '</button>';
    }).join('');

    return '<div class="drug-prompts-cta">' +
               '<div class="drug-prompts-cta__heading">' +
                   '<p class="drug-prompts-cta__title">Check Before Prescribing</p>' +
               '</div>' +
               '<div class="drug-prompts-cta__prompts">' +
                   promptsHtml +
               '</div>' +
           '</div>';
}

module.exports = {
    drugPromptsTemplate: drugPromptsTemplate
};
